module.exports = __webpack_public_path__ + "static/img/2-2-new.7e28800.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/home/images/2-2-new.png
// module id = 948
// module chunks = 30